



































































import { defineComponent, toRefs, PropType, computed, ref, Ref } from '@vue/composition-api';
import {
  AdgroupFormData,
  CampaignFormData,
  FullNormalFormData,
  NormalCreative,
  PrecheckResult,
} from '@tt4b/ttam-enums';
import {
  useStdObjectiveType,
  useCreativeIs,
  useMaterialData,
  useCreativeActionTypeIs,
  useStdCreativeAdgroupIs,
  useCreativeVideoUpload,
  useStdAdgroupIs,
  useStdAdTypeStatus,
  useCreativeIos14Quota,
} from '@tt4b/ttam-hooks';
import AdList from './index';
import { isCreativeEmpty } from '@tt4b/ttam-utils';

const name = 'ttam-ad-list-compose';

export default defineComponent({
  name,
  components: {
    TtamAdListHeader: AdList.TtamAdListHeader,
    TtamAdListButtons: AdList.TtamAdListButtons,
    TtamAdListItem: AdList.TtamAdListItem,
  },
  props: {
    addLoading: { type: Boolean, default: false },
    copyLoading: { type: Boolean, default: false },
    isDisabledCreative: { type: Boolean, default: false },
    isSketchSaving: { type: Boolean, default: false },
    activeCreativeIndex: { type: Number, default: 0 },
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    creativeData: {
      type: Object as PropType<FullNormalFormData>,
      default: () => ({}),
    },
    normalCreativeList: {
      type: Array as PropType<NormalCreative[]>,
      default: () => [],
    },
    createMode: {
      type: String,
      default: 'create',
    },
    /** 表单验证状态 */
    validateStatus: {
      type: Array as PropType<boolean[]>,
      default: () => [],
    },
    precheckResult: {
      type: Object as PropType<PrecheckResult>,
      default: () => ({}),
    },
    existCreatives: {
      type: Number,
      default: 0,
    },
    publishedUuids: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
  },
  setup(props) {
    const {
      isDisabledCreative,
      createMode,
      campaignData,
      adgroupData,
      normalCreativeList,
      activeCreativeIndex,
      validateStatus,
      precheckResult,
      existCreatives,
      copyLoading,
      addLoading,
      publishedUuids,
      isSketchSaving,
    } = toRefs(props);
    const { isSupportCatalogCarousel, isSupportCarouselImage } = useStdAdTypeStatus({
      adgroupFormData: adgroupData,
      campaignFormData: campaignData,
    });

    const normalCreativeData = computed(() => normalCreativeList.value[activeCreativeIndex.value]);
    const { isProductSales } = useStdObjectiveType({ campaignFormData: campaignData });
    const { isLiveAds } = useStdCreativeAdgroupIs({
      campaignFormData: campaignData,
      adgroupFormData: adgroupData,
    });
    const { isRealTimeLive } = useCreativeIs({
      createMode,
      campaignFormData: campaignData,
      adgroupFormData: adgroupData,
      normalCreativeData,
    });

    const {
      isHasPangle,
      isStandardAdsWithShop,
      isProductSalesCloseLoopVSAWithPangle,
      isProductFromShop,
      isProductFromShowcase,
    } = useStdAdgroupIs({
      campaignFormData: campaignData as Ref<CampaignFormData>,
      adgroupFormData: adgroupData as Ref<AdgroupFormData>,
    });

    // 闭环不显示 CatalogImage
    const isShowCatalogImage = computed(() => isHasPangle.value && !isProductSalesCloseLoopVSAWithPangle.value);

    const {
      singleImageCreativeCount,
      singleVideoCreativeCount: _singleVideoCreativeCount,
      carouselImageCreativeCount,
      catalogVideoCreativeCount,
      catalogImageCreativeCount,
      smartCreativeCount,
      catalogCarouselCount,
    } = useMaterialData({
      normalCreativeList,
    });
    const singleVideoCreativeCount = computed(() => (isRealTimeLive.value ? 1 : _singleVideoCreativeCount.value));
    // TODO 待split test支持
    const isControlGroup = ref(false);

    const copyCreativeUuid = ref('');
    const handleCopy = index => {
      copyCreativeUuid.value = normalCreativeList.value[index]?.creativeUuid;
    };

    const { formattedList } = AdList.usePropsCreativeFormattedList({
      normalCreativeList,
      campaignData,
      adgroupData,
      isProductSales,
      isLiveAds,
      isControlGroup,
      validateStatus,
      precheckResult,
      existCreatives,
      createMode,
      copyLoading,
      copyCreativeUuid,
    });

    const maxCreativeLimit = AdList.useMaxCreativeLimit({
      campaignData,
      adgroupData,
      isRealTimeLive,
    });

    const { ios14Quota, hasIos14CreativeQuota } = useCreativeIos14Quota();
    const { disabledHint } = AdList.useMaxCreativeLimitHint();

    const isDisabledAddBtn = computed(() => {
      const lastCreative = normalCreativeList.value[normalCreativeList.value.length - 1];
      const maxCreativeDisabled = hasIos14CreativeQuota.value
        ? normalCreativeList.value.length >= ios14Quota.value.creativeQuota.availableQuota
        : normalCreativeList.value.length >= maxCreativeLimit.value - existCreatives.value;
      const { isUploading } = useCreativeVideoUpload();
      return (
        isDisabledCreative.value ||
        isCreativeEmpty(lastCreative) ||
        maxCreativeDisabled ||
        isRealTimeLive.value ||
        isUploading.value ||
        copyLoading.value
      );
    });

    const { isUploading } = useCreativeVideoUpload();
    const isListItemBtnDisabled = computed(
      () => isDisabledCreative.value || isUploading.value || addLoading.value || isSketchSaving.value,
    );

    const { isCopyCreative } = useCreativeActionTypeIs({
      adgroupFormData: adgroupData,
      createMode,
    });

    const isShowAdListButton = computed(() => !isCopyCreative.value);

    const isShowVideoProcess = computed(() => !isProductSales.value);

    const isShowCreativeTypeCount = computed(() => !isLiveAds.value);
    const isProductSalesAndShopOrShowCase = computed(
      () => isProductSales.value && (isProductFromShop.value || isProductFromShowcase.value),
    );

    const getIsPublished = (uuid: string) => publishedUuids.value.includes(uuid);

    return {
      formattedList,
      maxCreativeLimit,
      isDisabledAddBtn,
      isListItemBtnDisabled,
      isSupportCarouselImage,
      singleImageCreativeCount,
      singleVideoCreativeCount,
      catalogVideoCreativeCount,
      catalogImageCreativeCount,
      smartCreativeCount,
      catalogCarouselCount,
      carouselImageCreativeCount,
      isCopyCreative,
      isShowVideoProcess,
      isShowCreativeTypeCount,
      isShowAdListButton,
      handleCopy,
      isShowCatalogImage,
      isSupportCatalogCarousel,
      isStandardAdsWithShop,
      isProductSalesAndShopOrShowCase,
      getIsPublished,
      disabledHint,
    };
  },
});
